import { useQuery } from '@apollo/client/react';
import { DashboardProject, ProjectData, ZONE_PRIORITY, GET_PROJECT_DETAILS } from 'domain/shared/newProject';
import { NetworkStatus, OperationVariables } from '@apollo/client';

export const sortProjectsByZonePriority = (projects: DashboardProject[]): DashboardProject[] => {
  return [...projects].sort((a, b) => {
    const priorityA = ZONE_PRIORITY[a.projectHealthZone] || 0;
    const priorityB = ZONE_PRIORITY[b.projectHealthZone] || 0;

    return priorityB - priorityA;
  });
};

export const useProjectDetails = (projectId?: string | number) => {
  const { data, loading, error, refetch, networkStatus } = useQuery<{ baseProject: ProjectData }>(GET_PROJECT_DETAILS, {
    variables: { id: projectId?.toString() },
    skip: !projectId,
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  const refetchProject = async (variables?: Partial<OperationVariables>) => {
    return refetch(variables).then(() => data?.baseProject);
  };

  return {
    project: data?.baseProject,
    loading,
    error,
    refetch: refetchProject,
    isDataReloading: !error && (!data || networkStatus !== NetworkStatus.ready),
  };
};
